import React, { Component } from 'react'
import WithClickOutside from 'react-click-outside'

const grayBorder = '#e8e5e5'
const styles = {
  date: {
    border: `1px solid ${grayBorder}`,
    padding: '5px',
    background: 'rgba(255,255,255,0.5)',
    margin: '0 0 10px 0'
  },
  text: {
    border: `1px solid ${grayBorder}`,
    width: '100px',
    padding: '5px'
  }
}

// Input fields used in the note
class NoteInput extends Component {
  handleClickOutside = () => {
    this.toggle()
  }

  toggle = () => {
    this.props.onToggle(this.props.typeOfField)
  }

  render () {
    const { onBlur, onChange, defaultValue, type, dataCy } = this.props

    return (
      <input
        style={styles[type]}
        type={type}
        onBlur={onBlur}
        onChange={onChange}
        defaultValue={defaultValue}
        data-cy={dataCy}
        max='9999-12-31'
      />
    )
  }
}

export default WithClickOutside(NoteInput)
